import React, {useState,useEffect} from 'react';
import {useSelector} from 'react-redux'
import * as S from './SelectSeatTabContent.styles';
import BoardingDropingBox from '../../BusDetailedCard/BoardingDropingBox/BoardingDropingBox';
import BusBerth from '../../BusDetailedCard/BusBerth/BusBerth';
import Icon from '../../../../../../stories/core-components/IconsSelector';
import { useHistory } from 'react-router-dom';
import ContentUnavailable from '../../SrpErrorStates/ContentUnavailable';
import Loader from '../../SrpLoader/Loader/Loader';
import LineLoader from '../../../../../../stories/core-components/LineLoader/LineLoader';
import {SEAT_LAYOUT} from './../../../../../config/messages';
import {scrollEletoView} from './../../../../../containers/Common/Utils';
import {IBUS_SEAT_LAYOUT_DATA_IMPULSE} from './../../../../../containers/SeatLayout/helpers/validation'
import PriceTabView from './PriceTabView';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, calculateDroppingDate } from '../../../../../utils/ctaHelper'
import { CTA_TYPE, pushOmniEvents } from '../../../../../utils/PushEvents/Omniture/utils'
import { commonSelector, routeStateSelector } from '../../../../../containers/Common/redux/selectors'
import { IUserStoreState, userSelector } from 'user-reducer/src/user-reducer';
import { userLoyaltyInfo } from '../../../../../containers/Home/redux/selectors';

type seatLayoutprops = {
  seatCategory?: boolean;
  selectedSeatLayoutInfo?: any;
  bid: string;
  busSeatData?: any;
  onSeatClick?: any;
  onPriceSelect?: any;
  onBoardingPointSelect?: any;
  onDroppingPointSelect?: any;
  availableSeatPrice?: any;
  cat_card?: boolean;
  onCategorySelect?: any;
  redDealData?: any;
  bps?: any;
  dps?: any;
  chooseBpDpFirst?: boolean;
  onContinueSeat: Function;
  isFareUpdating: boolean;
  cat_list: object;
  routeId:string;
  busData?:any
};

const SelectSeatTabContent = (props: seatLayoutprops) => {
  const {
    seatCategory = true,
    bid,
    selectedSeatLayoutInfo,
    busSeatData,
    onSeatClick,
    onPriceSelect,
    onBoardingPointSelect,
    onDroppingPointSelect,
    cat_card,
    onCategorySelect,
    chooseBpDpFirst,
    onContinueSeat,
    isFareUpdating,
    cat_list,
    routeId,
    busData
  } = props;
  const history = useHistory();
  const userDetails = useSelector(userSelector) as IUserStoreState;
  const routeStates = useSelector(routeStateSelector)
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const {userInfo, loyaltyInfo={}} = userDetails;
  const [errorStates, setErrorState] = useState({bp: '', dp: ''});
  let {bps, dps} = props;
  const {selectedPrice, fareInfo, selectedCategory, redDealInfo} = selectedSeatLayoutInfo;
  const {priceWithoutDiscount, priceAfterDiscount} = getFareAfterRedDeal(fareInfo, redDealInfo);
  const selectedSeatText = getSeatSelectedView(selectedSeatLayoutInfo);
  const commonData = useSelector(commonSelector);
  const userLoyalty = useSelector(userLoyaltyInfo)
  const userTier = userLoyalty?.userLoyaltyInfo?.user_tier === undefined ? '' : `${userLoyalty?.userLoyaltyInfo?.user_tier}`
  const {doj,dojObj,src,dest} = commonData;
  const isSeatDataPresent = busSeatData && busSeatData.data && Object.keys(busSeatData.data).length;
  const {
    operatorName,
    rating,
    departureTime,
    duration,
    arrivaleTime,
    seatsAvailable,
    aws,
  } = busData;
  /************************************************************************* */
  //TODO:- extract this part and seatLayout to another component so these conditions can be removed
  let route_id = '',
    seats = {
      upper_deck: {},
      lower_deck: {},
    },
    availableSeatPrice = [],
    upper_deck = {},
    lower_deck = {},
    fareDetails: [],
    totalTax=0,
    actualFare = 0,
    discountedFare = 0,
    fareInfoView = [],
    redDealView = [],
    impulse ={} as IBUS_SEAT_LAYOUT_DATA_IMPULSE;
    useEffect(() => {
      const idOfElToScrollTo = `#seatSection${routeId.replace('@', '')}`;
      scrollEletoView(idOfElToScrollTo, {
        behavior: 'smooth',
      });
      let eventDetails = {
        page: {
          pageInfo: {
            section: "domestic bus funnel",
            pageName: "funnel:domestic bus:details:seatlayout",
            pageType: "funnel",
            lob: "domestic bus",
            siteName: 'GI',
            platform: 'dweb',
            flow: "direct-bus",
            loadedComponents: 'BP/DP|SeatLayout',
            abVariant: '',
            deviceId: "",
            loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`          },
        },
        account: {
          accountInfo: {
            custID: userInfo?.userid ? `${userInfo?.userid}` : '',
            loginStatus: isLoggedIn ? "Logged-In" : "Guest",
            goCash: userDetails ? userDetails?.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "" : '',
            loyaltyStatus: userTier,
            "hydraSegment": "",
          },
        },
        booking: {
          routeCity: `${src}-${dest}`,
          routeState: (routeStates.srcState && routeStates.destState) ? `${routeStates.srcState}-${routeStates.destState}` : '',
          daysToTrip: `${calculateDaysToTrip(dojObj)}`,
          departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(doj)}`,
        },
      }
      pushOmniEvents({ eventName: 'pageView', details: eventDetails });
    }, [])
    
  /************************************************************************* */
  if ((busSeatData && busSeatData.error && !chooseBpDpFirst) || !busSeatData) {
    return (
      <S.SelectSeatTabContent id={`seatSection${routeId.replace('@', '')}`}>
        <ContentUnavailable
          iconName={SEAT_LAYOUT.SEAT_UNAVAILABLE_ICON}
          text={SEAT_LAYOUT.SEAT_ERROR}
        />
      </S.SelectSeatTabContent>
    );
  }
  if (!busSeatData.isLoading && busSeatData.data && !Object.keys(busSeatData.data).length && !chooseBpDpFirst) {
    return (
      <S.SelectSeatTabContent id={`seatSection${routeId.replace('@', '')}`}>
        <ContentUnavailable
          iconName={SEAT_LAYOUT.SEAT_UNAVAILABLE_ICON}
          text={SEAT_LAYOUT.SEAT_UNAVAILABLE}
        />
      </S.SelectSeatTabContent>
    );
  }
  if (busSeatData && busSeatData.isLoading && !chooseBpDpFirst) {
    return (
      <S.SelectSeatTabContent id={`seatSection${routeId.replace('@', '')}`}>
        <Loader />
      </S.SelectSeatTabContent>
    );
  }

  if (busSeatData.data && Object.keys(busSeatData.data).length) {
    
    route_id = busSeatData.data.route_id;
    seats = busSeatData.data.seats;
    availableSeatPrice = busSeatData.data.availableSeatPrice;
    fareDetails = busSeatData.data.fare_info;
    upper_deck = seats.upper_deck;
    lower_deck = seats.lower_deck;
    const fareDetailsInfo = getFareDetailsView(
      selectedSeatLayoutInfo,
      seats,
      fareDetails,
      busSeatData.data.fareBreakupMap,
    );
    fareInfoView = fareDetailsInfo.fareInfoView;
    totalTax = fareDetailsInfo?.totalTax;
    actualFare = fareDetailsInfo.actualFare;
    discountedFare = fareDetailsInfo.discountedFare;
    redDealView = getRedDealView(selectedSeatLayoutInfo, bid);
    bps = busSeatData.data.bps;
    dps = busSeatData.data.dps;
    impulse = busSeatData.data.impulse
  }
    return (
      <S.SelectSeatTabContent id={`seatSection${routeId.replace('@', '')}`}>
        <S.TabInnerContent>
          <section>
            {/* step1 */}
            <div>
              <S.StepHdrWrap  id={`seatView${routeId.replace('@', '')}`}>
                <span className="stepNumber" id={`bpdpError${route_id.replace('@', '')}`}>
                  <span>1</span>
                </span>

                {errorStates.bp || errorStates.dp ? (
                  <span className="stepHeaderTxt" style={{color: 'red'}}>
                    Please select boarding and dropping point to proceed.
                  </span>
                ) : (
                  <span className="stepHeaderTxt">Select boarding and dropping point</span>
                )}
              </S.StepHdrWrap>
              <S.StepContentWrap className="stepOneWrap">
                <div className="boxWrapper">
                  <p className="boxHeaders">Boarding Point</p>
                  <BoardingDropingBox
                    data={bps}
                    selectedItem={selectedSeatLayoutInfo.selectedBP}
                    onClick={data => {
                      if (errorStates.bp) {
                        let err = Object.assign({}, errorStates);

                        err['bp'] = '';
                        setErrorState(err);
                      }

                      onBoardingPointSelect(data);
                    }}
                  />
                </div>
                <div className="boxWrapper">
                  <p className="boxHeaders">Dropping Point</p>
                  <BoardingDropingBox
                    data={dps}
                    selectedItem={selectedSeatLayoutInfo.selectedDP}
                    onClick={data => {
                      if (errorStates.dp) {
                        let err = Object.assign({}, errorStates);

                        err['dp'] = '';
                        setErrorState(err);
                      }

                      onDroppingPointSelect(data);
                    }}
                  />
                </div>
              </S.StepContentWrap>
            </div>

            {/* step2 */}
            {cat_card ? (
              <div>
                <S.StepHdrWrap>
                  <span className="stepNumber">
                    <span>2</span>
                  </span>
                  <span className="stepHeaderTxt">Select Category</span>
                </S.StepHdrWrap>
                <S.StepContentWrap>
                  <div>
                    <S.SelectBoxWrap>
                      {/* <S.SelectArrow>
                        <Icon
                          name="DropArrowIcon"
                          styleProps={{fill: '#2276e3', width: '8px', height: '6px'}}
                        />
                      </S.SelectArrow> */}
                      <S.SelectDropDown onChange={onCategorySelect}>
                        {getCategoryOptionsView(bid, cat_list)}
                      </S.SelectDropDown>
                    </S.SelectBoxWrap>
                    {selectedCategory ? (
                      <p className="RowStyles">
                        <S.Tick>&#x2713;</S.Tick>
                        <span>{`You can book a maximum of ${cat_list[selectedCategory].ms} seats in this category.`}</span>
                      </p>
                    ) : null}
                  </div>
                </S.StepContentWrap>
              </div>
            ) : null}
          </section>
          {/* step3 */}
          <section>
            {(chooseBpDpFirst || cat_card) && busSeatData.isLoading? (
              <S.NoSeatCategoryBlock>
                <span style={{paddingLeft:"3rem",width:"100%"}}>
                <Loader count={1}></Loader>
                </span>
              </S.NoSeatCategoryBlock>
            ) : null}

            {cat_card && !isSeatDataPresent && !busSeatData.isLoading ? (
              <S.NoSeatCategoryBlock>
                <S.BlockTxt>
                {busSeatData.error ? SEAT_LAYOUT.SEAT_BP_DP_CAT_ERROR :'SELECT BOARDING/DROPPING POINT AND CATEGORY TO VIEW SEATS'}
    
                  </S.BlockTxt>
              </S.NoSeatCategoryBlock>
            ) : null}
            {!cat_card && chooseBpDpFirst && !isSeatDataPresent && !busSeatData.isLoading ? (
              <S.NoSeatCategoryBlock>
                <S.BlockTxt>
                  {busSeatData.error ? SEAT_LAYOUT.SEAT_BP_DP_ERROR :'SELECT BOARDING/DROPPING POINT TO VIEW SEATS'}
                  </S.BlockTxt>
              </S.NoSeatCategoryBlock>
            ) : null}
            {isSeatDataPresent && !busSeatData.isLoading ? (
              <section>
                <S.StepHdrWrap>
                  <span className="stepNumber">
                    <span>{cat_card ? 3 : 2}</span>
                  </span>
                  <span className="stepHeaderTxt">Select your seat</span>
                </S.StepHdrWrap>
                <S.StepContentWrap className="stepTwoWrap">
                  <S.SeatTypeMenu>
                    <S.SeatType>
                      <S.SeatBox className="bookedBg"></S.SeatBox>
                      <span className="seatTypeTxt">Booked</span>
                    </S.SeatType>
                    <S.SeatType>
                      <S.SeatBox className="availableBg"></S.SeatBox>
                      <span className="seatTypeTxt">Available</span>
                    </S.SeatType>
                    <S.SeatType>
                      <S.SeatBox className="ladiesBg"></S.SeatBox>
                      <span className="seatTypeTxt">Ladies</span>
                    </S.SeatType>
                    <S.SeatType>
                      <S.SeatBox className="menBg"></S.SeatBox>
                      <span className="seatTypeTxt">Men</span>
                    </S.SeatType>
                    <S.SeatType>

                    <Icon name='SeatBlockedViewIcon' />
                       <span className="seatTypeTxt">Blocked for social distancing</span>
                    </S.SeatType>

                  </S.SeatTypeMenu>
                  <S.priceTabWrap>
                    <PriceTabView  data={availableSeatPrice}
          selectedPrice={selectedPrice}
          route_id={route_id}
          bid={bid}
          selectedSeatLayoutInfo={selectedSeatLayoutInfo}
          onPriceSelect={onPriceSelect}
      ></PriceTabView>
                  </S.priceTabWrap>
                  {upper_deck && Object.keys(upper_deck).length ? (
                    <BusBerth
                      berthtitle="UPPER"
                      data={upper_deck}
                      selectedSeatLayoutInfo={selectedSeatLayoutInfo}
                      onSeatClick={onSeatClick}
                      showIcon={false}
                    />
                  ) : null}
                  {lower_deck && Object.keys(lower_deck).length ? (
                    <BusBerth
                      berthtitle="LOWER"
                      data={lower_deck}
                      selectedSeatLayoutInfo={selectedSeatLayoutInfo}
                      onSeatClick={onSeatClick}
                      showIcon={upper_deck && Object.keys(upper_deck).length ? true :false }
                      showIconOnly={!upper_deck || (upper_deck && !Object.keys(upper_deck).length)}
                    />
                  ) : null}
                  {!selectedSeatText ? (
                    <S.Button className="disabledButton">SELECT SEATS TO PROCEED</S.Button>
                  ) : null}
                  {selectedSeatText ? (
                    <S.Button
                      onClick={() => {
                         // ADd RouteID to url
                        const url = new URL(window.location.href);
                        url.searchParams.set('routeId', routeId);
                        history.replace(url.search);
                        const selectedBP = selectedSeatLayoutInfo.selectedBP;
                        const selectedDP = selectedSeatLayoutInfo.selectedDP;
                        let data = Object.assign({}, errorStates);

                        if (bps && bps.length && !Object.keys(selectedBP).length) {
                          data['bp'] = 'Please select boarding point to proceed.';
                        }
                        if (dps && dps.length && !Object.keys(selectedDP).length) {
                          data['dp'] = 'Please select dropping point to proceed.';
                          setErrorState(data);
                        }
                        if (data.bp || data.dp) {
                          setErrorState(data);

                          const idOfElToScrollTo = `#bpdpError${route_id.replace('@', '')}`;
                          scrollEletoView(idOfElToScrollTo, {
                            behavior: 'smooth',
                          });
                          return;
                        }
                        const eventDetails = {
                          page: {
                            pageInfo: {
                              section: "domestic bus funnel",
                              pageName: "funnel:domestic bus:funnel",
                              pageType: "funnel",
                              lob: "domestic bus",
                              siteName: 'GI',
                              platform: 'dweb',
                              flow: "direct-bus",
                              loadedComponents: 'BP/DP|SeatLayout',
                              abVariant: '',
                              deviceId: "",
                              loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`                            },
                          },
                          account: {
                            accountInfo: {
                              custID: userInfo?.userid? `${userInfo?.userid}` :'',
                              loginStatus:  isLoggedIn? "Logged-In" : "Guest",
                              goCash: userDetails?userDetails.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "":'',
                              loyaltyStatus: userTier,
                              "hydraSegment": "",
                            },
                          },
                          cta: ctaHelper(['Bus_Seat_Selected', CTA_TYPE.BUTTON, 'Card_Footer', 'Review']),
                          productListItems: [{
                              SKU: bid,
                              productInfo: {
                                  productName: operatorName,
                                  productPosition: '',
                                  busNitroDealsBanner: busData.is_nitro ? 'Y' : 'N',
                                  "busLoginDealsBanner": busData.reddeal ? busData.reddeal?.persuasion ?'Y':'N' : 'N',
                              }
                          }],
                          booking: {
                              routeCity: `${src}-${dest}`,
                              routeState : (routeStates.srcState && routeStates.destState) ?  `${routeStates.srcState}-${routeStates.destState}` : '',
                              daysToTrip:`${calculateDaysToTrip(dojObj)}`,
                              departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(doj)}`,
                              droppingDate:`${calculateDroppingDate(convert_yyyymmdd_to_dd_mm_dddd(doj), departureTime, arrivaleTime)}`,
                              departureTime: `${departureTime}`,
                              droppingTime: `${arrivaleTime}`,
                              boardingPoint:`${selectedBP.n}`,
                              droppingPoint:`${selectedDP?.n}`,
                              duration: `${duration}`,
                              AvailabeSeats: `${seatsAvailable}`,
                              AvailabeWindowSeats: `${aws}`,
                              Ratings: rating?`${rating}`:'',
                              seatNumber:selectedSeatText,
                              numberOfSeats:`${selectedSeatText?.split(',').length}`,
                              baseFare: `${actualFare}`,
                              taxAmount: `${totalTax}`,
                              discount: `${Math.round(actualFare-discountedFare)}`,
                          },
                        };
                        cat_card?eventDetails.booking['busBookingCategory'] = selectedCategory:null;
                        pushOmniEvents({ eventName: 'busSLPageContinue', details: eventDetails });
                        onContinueSeat();
                      }}
                    >
                      CONTINUE
                    </S.Button>
                  ) : null}
                  <S.FarePrice>
                    <aside>
                      {selectedSeatText ? (
                        <>
                          <p className="selTxt">Seat selected</p>
                          <p className="selSeat">{selectedSeatText}</p>
                        </>
                      ) : null}
                    </aside>
                    <aside className="asideRight">
                      {isFareUpdating ? (
                        <LineLoader width="11.5rem" />
                      ) : (
                        <>
                          <p>
                            {actualFare && actualFare !== discountedFare ? (
                              <span className="strikeoutPrice">{Math.floor(actualFare)}</span>
                            ) : null}
                            {discountedFare ? (
                              <span className="totalPriceTxt">₹{Math.floor(discountedFare)}</span>
                            ) : null}
                          </p>
                          {selectedSeatText ? (
                            <div className="fareLinkTxt">
                              <S.Tooltip>
                                Fare Details
                                <div className="top">
                                  <h3>Fare Breakup</h3>
                                  <div className="priceListWrap">
                                    {fareInfoView}
                                    <div className="discountInnerWrap">{redDealView}</div>
                                  </div>

                                  <div className="priceRow priceRowFooter">
                                    <div>
                                      <p className="totalPrice">Total</p>
                                      <p className="smallTxt">
                                      Taxes will be calculated before payment
                                      </p>
                                    </div>
                                    <div className="totalPrice">₹{Math.floor(discountedFare)}</div>
                                  </div>
                                  <i></i>
                                </div>
                              </S.Tooltip>
                            </div>
                          ) : null}
                        </>
                      )}
                    </aside>
                  </S.FarePrice>
                  {impulse && impulse.tags && impulse.tags.length ? (
                    <S.BusAmenities>
                      <span className="txtContent">People loved the bus for it's</span>
                      <div className="list">
                        {
                          impulse.tags.map(function(tag,index){
                            if(index < 2){
                            return <span key={tag+routeId} className="listTab">{tag}</span>
                            }
                          })
                        }
                      </div>
                    </S.BusAmenities>
                  ) :null}


                  {impulse && impulse.c && !impulse.tags && !impulse.tags.length ?
                      <S.BusAmenities>
                      <span className="txtContent" style={{color:impulse.c}}>{impulse.t}</span>
                    </S.BusAmenities>
                  
                  : null}
                
                  
                  
                </S.StepContentWrap>
              </section>
            ) : null}
          </section>
        </S.TabInnerContent>
      </S.SelectSeatTabContent>
    );
  
};
export default SelectSeatTabContent;


function getSeatSelectedView(selectedSeatLayoutInfo) {
  let str = '';
  const selectedSeats = selectedSeatLayoutInfo.selectedSeats;
  for (let key in selectedSeats) {
    if (selectedSeats.hasOwnProperty(key) && selectedSeats[key].length) {
      str += (str.length ? ',' : '') + selectedSeats[key].join(',');
    }
  }
  return str;
}
function getFareDetailsView(selectedSeatLayoutInfo, seats, fareDetails, groupedFareBreakupMap) {
  //NOTE:- ideally all the keys are in groupedFareBreakup except Base Fare
  var fareInfoView = [];
  var discountedFare = 0;
  var discount = 0;
  var groupedView = {};
  let totalTax = 0;
  const selectedSeats = selectedSeatLayoutInfo.selectedSeats;
  const redDealInfo = selectedSeatLayoutInfo.redDealInfo;
  if (redDealInfo && redDealInfo.disc_val) {
    discountedFare += redDealInfo.disc_val;
    discount -= parseInt(redDealInfo.disc_val);
  }

  //TODO:- discountPrice classname based on some key.
  for (let i in fareDetails) {
    let isGroupedKey = false;
    let discounted = false;
    const key = fareDetails[i].k;
    const title = fareDetails[i].v;
    const evaluate = fareDetails[i].e;
    if (fareDetails[i].s) {
      let val = 0;
      for (let deck in selectedSeats) {
        if (selectedSeats.hasOwnProperty(deck)) {
          const deckSeats = selectedSeats[deck];

          for (let seatname in deckSeats) {
            val += seats[deck][deckSeats[seatname]][key];
          }
        }
      }

      for (const groupName in groupedFareBreakupMap) {
        if (
          groupedFareBreakupMap.hasOwnProperty(groupName) &&
          groupedFareBreakupMap[groupName].indexOf(key) !== -1
        ) {
          discounted = false;

          isGroupedKey = true;
          if (groupName.toLowerCase() === 'discount') {
            discounted = true;
          }
          if (!groupedView.hasOwnProperty(groupName)) {
            groupedView[groupName] = {data: [], totalAmount: 0};
          }
          groupedView[groupName].data.push({title, val, discounted});
          groupedView[groupName].totalAmount += val;
        }
      }
      if (evaluate) {
        if (discounted) {
          discountedFare -= val;
        } else {
          discountedFare += val;
        }
      }

      if (!isGroupedKey && val) {
        fareInfoView.push(
          <p key={i + Date.now()} className="priceRow">
            <span className={`${discounted ? 'discountPrice' : ''}`}>{title}</span>
            <span className={`${discounted ? 'discountPrice' : ''}`}>₹{val.toFixed(2)}</span>
          </p>,
        );
      }
    }
  }
  totalTax = groupedView && groupedView['Taxes & fees']? groupedView['Taxes & fees']?.totalAmount : 0;
  for (const k in groupedView) {
    if (groupedView[k].totalAmount !== undefined) {
      const data = groupedView[k].data;
      fareInfoView.push(
        <React.Fragment key={k}>
          <p
            key={k + Date.now()}
            className={`priceRow ${k.toLowerCase() === 'discount' ? 'discountPrice' : ''}`}
          >
            <span className={`${groupedView[k].discounted ? 'discountPrice' : ''}`}>{k}</span>
            <span className={`${groupedView[k].discounted ? 'discountPrice' : ''}`}>
              ₹{groupedView[k].totalAmount + discount}
            </span>
          </p>

          <div className="discountInnerWrap">
            {data &&
              data.map(function(obj, index) {
                return (
                  <p className="priceRow" key={index + obj.title + obj.val}>
                    <span className={`${obj.discounted ? 'discountPrice' : ''}`}>{obj.title}</span>
                    <span className={`${obj.discounted ? 'discountPrice' : ''}`}> ₹{obj.val}</span>
                  </p>
                );
              })}
          </div>
        </React.Fragment>,
      );
    }
  }
  return {fareInfoView, discountedFare, actualFare: discountedFare + discount, totalTax};
}
function getRedDealView(selectedSeatLayoutInfo, bid) {
  let view = [];
  const redDealInfo = selectedSeatLayoutInfo.redDealInfo;
  if (redDealInfo && redDealInfo.disc_val) {
    view.push(
      <p key={bid + 'redDealDiscount'} className="priceRow">
        <span className="discountPrice">{redDealInfo.disc_txt}</span>
        <span className="discountPrice">{`- ₹${-redDealInfo.disc_val.toFixed(2)}`}</span>
      </p>,
    );
  }
  return view;
}

function getCategoryOptionsView(bid, cat_list) {
  const view = [];
  for (let key in cat_list) {
    if (cat_list.hasOwnProperty(key)) {
      view.push(
        <option key={key + bid} value={key}>
          {cat_list[key].title}
        </option>,
      );
    }
  }
  return view;
}
function getFareAfterRedDeal(fareInfo, redDealInfo) {
  let {priceWithoutDiscount, priceAfterDiscount} = fareInfo;

  if (redDealInfo && redDealInfo.disc_val) {
    priceAfterDiscount += redDealInfo.disc_val;
  }
  return {priceWithoutDiscount, priceAfterDiscount};
}
